import React, { useState, useEffect } from 'react';
import { Layout, Menu, Breadcrumb, Card, Typography, Button, Modal, Form, Input, Rate, Divider, Tabs, Collapse, List, Tag, Space, message } from 'antd';
import { HomeOutlined, FileTextOutlined, VideoCameraOutlined, QuestionCircleOutlined, MailOutlined, StarOutlined, SearchOutlined, BookOutlined, PlayCircleOutlined, ClockCircleOutlined, SendOutlined } from '@ant-design/icons';

const { Header, Content, Sider } = Layout;
const { Title, Paragraph, Text } = Typography;
const { TabPane } = Tabs;
const { Panel } = Collapse;
const { TextArea } = Input;

const HelpCenterModule = () => {
  const [currentView, setCurrentView] = useState('home');
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  const faqData = [
    { key: '1', question: '如何导入遥感碳储量数据？', answer: '请进入【数据导入】模块，点击“选择文件”按钮上传符合格式的GeoTIFF 或NetCDF文件，系统将自动解析并展示在地图上。' },
    { key: '2', question: '导出结果支持哪些格式？', answer: '目前支持导出为GeoTIFF、CSV 和 Shapefile 格式，可在导出设置中选择所需格式。' },
    { key: '3', question: '系统运行缓慢怎么办？', answer: '建议检查网络连接，关闭不必要的浏览器标签页。若问题持续，请尝试清理缓存或联系技术支持。' },
    { key: '4', question: '是否支持多用户协作？', answer: '当前版本暂不支持实时协作，但可通过项目共享功能分发配置文件实现团队协同工作。' },
  ];

  const userManualSections = [
    { title: '安装与配置', items: ['系统环境要求', '本地部署指南', '数据库初始化', '权限配置说明'] },
    { title: '核心功能使用', items: ['遥感数据加载', '碳储量反演流程', '时空分析工具', '可视化图层控制'] },
    { title: '故障排除', items: ['常见错误代码解析', '日志查看方法', '性能优化建议', '联系技术支持方式'] },
  ];

  const tutorialVideos = [
    { title: '快速入门：5分钟掌握系统基础操作', duration: '5:23', views: '1.2k' },
    { title: '高级功能详解：自定义反演参数与模型调优', duration: '12:47', views: '890' },
    { title: '数据导出与GIS集成实战演示', duration: '8:11', views: '1.5k' },
  ];

  const handleOk = async () => {
    try {
      await form.validateFields();
      message.success('感谢您的反馈！我们将尽快处理。');
      form.resetFields();
      setVisible(false);
    } catch (errorInfo) {
      message.error('请完整填写必填项！');
    }
  };

  const renderContent = () => {
    switch (currentView) {
      case 'faq':
        return (
          <Card title="常见问题解答 (FAQ)">
            <Collapse accordion>
              {faqData.map(item => <Panel header={item.question} key={item.key}><p>{item.answer}</p></Panel>)}
            </Collapse>
          </Card>
        );
      case 'manual':
        return (
          <Card title="操作手册">
            <Tabs defaultActiveKey="1">
              {userManualSections.map((section, index) => (
                <TabPane tab={section.title} key={index + 1}>
                  <List bordered dataSource={section.items} renderItem={item => <List.Item><BookOutlined /> <span style={{ marginLeft: 8 }}>{item}</span></List.Item>} />
                </TabPane>
              ))}
            </Tabs>
          </Card>
        );
      case 'videos':
        return (
          <Card title="视频教程">
            <List
              grid={{ gutter: 16, column: 3 }}
              dataSource={tutorialVideos}
              renderItem={item => (
                <List.Item>
                  <Card title={item.title} hoverable actions={[<PlayCircleOutlined key="play" onClick={() => message.info('播放视频')} />]}>
                    <Space><ClockCircleOutlined /> {item.duration}</Space>
                    <br />
                    <Text type="secondary">{item.views} 观看</Text>
                  </Card>
                </List.Item>
              )}
            />
          </Card>
        );
      default:
        return (
          <div style={{ textAlign: 'center', padding: 50 }}>
            <Title level={2}>欢迎使用帮助中心</Title>
            <Paragraph>在这里您可以找到关于“遥感反演碳储量结果可视化与导出系统”的所有使用指导。</Paragraph>
            <Space size="large">
              <Button type="primary" size="large" icon={<BookOutlined />} onClick={() => setCurrentView('manual')}>查看手册</Button>
              <Button size="large" icon={<VideoCameraOutlined />} onClick={() => setCurrentView('videos')}>观看教程</Button>
            </Space>
          </div>
        );
    }
  };

  return (
    <Layout style={{ minHeight: '100vh', background: '#fff' }}>
      <Sider theme="light" width={200}>
        <Menu mode="inline" selectedKeys={[currentView]} onClick={e => setCurrentView(e.key)} style={{ height: '100%' }}>
          <Menu.Item key="home" icon={<HomeOutlined />}>首页</Menu.Item>
          <Menu.Item key="faq" icon={<QuestionCircleOutlined />}>常见问题</Menu.Item>
          <Menu.Item key="manual" icon={<FileTextOutlined />}>操作手册</Menu.Item>
          <Menu.Item key="videos" icon={<VideoCameraOutlined />}>视频教程</Menu.Item>
          <Menu.Item key="feedback" icon={<MailOutlined />} onClick={() => setVisible(true)}>提交反馈</Menu.Item>
        </Menu>
      </Sider>
      <Content style={{ padding: '24px' }}>
        {renderContent()}
      </Content>
      
      <Modal title="用户反馈" open={visible} onOk={handleOk} onCancel={() => setVisible(false)}>
        <Form form={form} layout="vertical">
          <Form.Item name="subject" label="反馈主题" rules={[{ required: true }]}><Input /></Form.Item>
          <Form.Item name="content" label="反馈内容" rules={[{ required: true }]}><TextArea rows={4} /></Form.Item>
          <Form.Item name="rating" label="满意度"><Rate /></Form.Item>
        </Form>
      </Modal>
    </Layout>
  );
};

export default HelpCenterModule;